import config from '../config.js';
export default config.appEnv === 'production';
//# sourceMappingURL=index.js.map